import { Pipe, PipeTransform } from '@angular/core';
import {UtilityService} from "@irb-common/services/utility.service";

@Pipe({
  name: 'decodeHtml', standalone: false
})
export class DecodeHtmlPipe implements PipeTransform {

  constructor(private util: UtilityService) { }
  transform(value: string) {
    return this.util.htmlDecode(value); // getting html symbols from their text representation (a.e. &lt;&gt; -> <>)
  }

}
